// Services Data
export const services = [
  {
    id: 'glow-guide',
    name: 'The Glow Guide',
    tagline: 'Light-touch styling, high-style results',
    shortDesc: 'A 45-minute virtual consultation for hosts who want expert insight without the full-service price tag.',
    fullDesc: 'The Glow Guide is our light-touch, high-style consultation for hosts who want professional insight without the full-service price tag. In just 45 minutes, we\'ll walk through your vision, offer curated recommendations, and send you off with a personalized moodboard, checklist, and timeline to make it all happen — beautifully.',
    icon: '✨',
    image: 'https://images.unsplash.com/photo-1478146896981-b80fe463b330?w=800&q=80',
    startingPrice: '$150',
    priceRange: { min: 150, max: 200 },
    idealFor: 'Hosts on a tight budget or planning small gatherings',
    includes: [
      '45-minute virtual styling session (Zoom or phone)',
      'Personalized party moodboard + color palette',
      'Custom event timeline + checklist',
      'Follow-up email with tips & sourcing links'
    ],
    addons: [
      { name: 'Menu card template design', price: '$35' },
      { name: 'Printable signage pack', price: '$45' }
    ],
    pricing: [
      { guests: 'Any size', price: '$150–$200' }
    ]
  },
  {
    id: 'golden-touch',
    name: 'The Golden Touch',
    tagline: 'Design consult + setup plan',
    shortDesc: 'Comprehensive design consultation with a detailed setup plan for your perfect event.',
    fullDesc: 'Get the full design experience with a comprehensive consultation and detailed setup plan. We\'ll work together to create your perfect event aesthetic and provide you with everything you need to bring it to life.',
    icon: '🌟',
    image: 'https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=800&q=80',
    startingPrice: '$500',
    priceRange: { min: 500, max: 1200 },
    idealFor: 'Hosts who want professional design guidance with hands-on setup support',
    includes: [
      'In-depth design consultation',
      'Complete moodboard & design concept',
      'Vendor recommendations',
      'Detailed setup guide & floor plan',
      'Shopping lists with links'
    ],
    addons: [
      { name: 'Day-of setup assistance', price: '$300' },
      { name: 'Venue walkthrough', price: '$150' }
    ],
    pricing: [
      { guests: '1–10 guests', price: '$500' },
      { guests: '11–25 guests', price: '$650' },
      { guests: '26–50 guests', price: '$850' },
      { guests: '51–75 guests', price: '$1,000' },
      { guests: '76–100 guests', price: '$1,200' }
    ]
  },
  {
    id: 'radiant-host',
    name: 'The Radiant Host',
    tagline: 'Partial setup + coordination',
    shortDesc: 'We handle the design and partial setup so you can focus on being the perfect host.',
    fullDesc: 'Let us take care of the heavy lifting. The Radiant Host package includes full design services plus partial setup and coordination, so you can relax and enjoy your event.',
    icon: '🕯️',
    image: 'https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=800&q=80',
    startingPrice: '$1,200',
    priceRange: { min: 1200, max: 2200 },
    idealFor: 'Hosts who want to be present and relaxed on event day',
    includes: [
      'Full design consultation & concept',
      'Vendor coordination',
      'Partial day-of setup',
      'Timeline management',
      'Setup supervision & styling'
    ],
    addons: [
      { name: 'Custom invitation suite', price: '$150' },
      { name: 'Guest gift sourcing', price: '$200' },
      { name: 'Additional staff/hour', price: '$75–100/hr' }
    ],
    pricing: [
      { guests: '1–25 guests', price: '$1,200' },
      { guests: '26–50 guests', price: '$1,500' },
      { guests: '51–75 guests', price: '$1,800' },
      { guests: '76–100 guests', price: '$2,200' }
    ]
  },
  {
    id: 'full-affair',
    name: 'The Full Affair',
    tagline: 'Full design, setup & management',
    shortDesc: 'The complete luxury experience — we handle everything from concept to cleanup.',
    fullDesc: 'The ultimate party experience. From initial concept to final cleanup, we manage every detail of your event so you can simply show up and celebrate. This is full-service event styling at its finest.',
    icon: '👑',
    image: 'https://images.unsplash.com/photo-1530103862676-de8c9debad1d?w=800&q=80',
    startingPrice: '$2,500',
    priceRange: { min: 2500, max: 8000 },
    idealFor: 'Hosts who want a completely hands-off, luxury experience',
    includes: [
      'Complete event design & concept',
      'Full vendor sourcing & management',
      'Complete setup & styling',
      'Day-of coordination',
      'Post-event cleanup',
      'Dedicated event manager'
    ],
    addons: [
      { name: 'Custom vendor sourcing (musicians, etc.)', price: '$250' },
      { name: 'Event branding kit (signage, menus, logo)', price: '$300' },
      { name: 'Full event content capture', price: '$500+' }
    ],
    pricing: [
      { guests: '1–25 guests', price: '$2,500' },
      { guests: '26–50 guests', price: '$3,200' },
      { guests: '51–75 guests', price: '$3,800' },
      { guests: '76–100 guests', price: '$4,500' },
      { guests: '100+', price: 'Custom Quote ($5K–$8K+)' }
    ]
  }
];

export default services;
